import React from 'react';
import c from '../w.js';

const IconArrowsCircle = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 12C6 8.68629 8.68629 6 12 6C13.0363 6 14.0084 6.26187 14.8568 6.72224L15.8107 4.96437C14.6767 4.34906 13.3776 4 12 4C7.58172 4 4 7.58172 4 12H6ZM18 12C18 15.3137 15.3137 18 12 18C10.9637 18 9.9916 17.7381 9.14318 17.2778L8.18931 19.0356C9.32325 19.6509 10.6224 20 12 20C16.4183 20 20 16.4183 20 12H21.7929C22.2383 12 22.4614 11.4614 22.1464 11.1464L19.3535 8.35355C19.1583 8.15829 18.8417 8.15829 18.6464 8.35355L15.8535 11.1464C15.5386 11.4614 15.7617 12 16.2071 12H18ZM1.85355 12.8536L4.64644 15.6464C4.84171 15.8417 5.15829 15.8417 5.35355 15.6464L8.14644 12.8536C8.46143 12.5386 8.23834 12 7.79289 12H2.2071C1.76165 12 1.53857 12.5386 1.85355 12.8536Z"
      }
    )
  )
);

export { IconArrowsCircle };
